import isOffline from '@/core/isOffline';

let setUser = function(state, payload) {
	if (state.currentUser.uid === payload.uid) {
		return;
	}
	state.currentUser = {
		uid: payload.uid,
		email: payload.email,
		displayName: payload.displayName,
		photoUrl: payload.photoURL,
	};
};
let clearUser = function(state) {
	state.currentUser = {
		uid: null,
		email: null,
		displayName: null,
		photoUrl: null,
	};
};
let setLoggedIn = function(state, payload) {
	if (isOffline()) state.isLoggedIn = true;
	state.isLoggedIn = payload;
};
let setHasAccess = function(state, payload) {
	state.hasAccess = payload;
};
let setIsVerified = function(state, payload) {
	state.isVerified = payload;
};
let setIsSuper = function(state, payload) {
	state.isSuper = payload;
};
let setTransporterCode = function(state, payload) {
	state.transporterCode = payload;
	localStorage.setItem('transporterCode', payload);
};
let setLastLogin = function(state, payload) {
	state.lastLogin = payload;
};

let setUsersWithAccess = function(state, payload) {
	state.usersWithAccess = payload;
};

let setSuperUsers = function(state, payload) {
	state.superUsers = payload;
};

let movetoSuperusers = function(state, userId) {
	let i = state.usersWithAccess.findIndex(user => user.id === userId);
	let user = state.usersWithAccess.splice(i, 1);
	state.superUsers.push(user[0]);
};

let movefromSuperusers = function(state, userId) {
	let i = state.superUsers.findIndex(user => user.id === userId);
	let user = state.superUsers.splice(i, 1);
	state.usersWithAccess.push(user[0]);
};

let setCompanies = function(state, payload) {
	state.companies = payload;
};

const clearTransporterCode = () => {
	localStorage.removeItem('transporterCode');
};

export default {
	setUser,
	clearUser,
	setLoggedIn,
	setHasAccess,
	setIsVerified,
	setIsSuper,
	setTransporterCode,
	setLastLogin,
	setUsersWithAccess,
	setSuperUsers,
	movetoSuperusers,
	movefromSuperusers,
	setCompanies,
	clearTransporterCode,
};